import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import CarContracrAddForm from "../../components/CarContract/Add/CarContractAddForm";
import { withRouter } from "react-router";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { QUERY_CAR_CONTRACT } from "../../service/ApolloClient/ApolloQueries";
import CarContractListAttachment from "./CarContractListAttachment";
import Loading from "../../components/UI/Loading/Loading";

export const CAR_CONTRACT_SELECT_EDIT = "CAR_CONTRACT_SELECT_EDIT";
export const CAR_CONTRACT_SELECT_ATTACHMENT = "CAR_CONTRACT_SELECT_ATTACHMENT";

class CarContractEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: CAR_CONTRACT_SELECT_EDIT,
    };
    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage = () => {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_CAR_CONTRACT,
        variables: {
          id: parseInt(this.state.id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = res.data.carContract;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };
  handleSelectPage = (page) => {
    this.setState({
      pageSelect: page,
    });
  };

  render() {
    const { loading, data, pageSelect } = this.state;

    let componentSelect = <Wrapper>در حال بارگزاری</Wrapper>;

    if (pageSelect === CAR_CONTRACT_SELECT_EDIT) {
      componentSelect = (
        <CarContracrAddForm
          handleSelectPage={this.handleSelectPage}
          data={data}
          isEdit={true}
        />
      );
    } else if (pageSelect === CAR_CONTRACT_SELECT_ATTACHMENT) {
      componentSelect = (
        <CarContractListAttachment
          carContract={data}
          handleBack={() => {
            this.handleSelectPage(CAR_CONTRACT_SELECT_EDIT);
          }}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش معاملات ماشین ",
              to: "/car-contract/edit",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(CarContractEditPage);
